export default (field) => ({
  default: field.default,
  name: field.name,
  options: field.options,
  rules: field.rules,
});
